import { app } from '../../../../../app';
import { Controller } from './directory-manage-domains.controller';

app.component('companyDirectoryIntegrationManageDomainsConfiguration', {
    bindings: {
        companyId: '<',
        directory: '<',
        domains: '<',
    },
    controller: Controller,
    templateUrl: require('./domains-configuration.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/domains/domains-configuration.component.js